import { useEffect, useRef, type ReactNode, type RefObject } from 'react'

export default function BoardControls({ open, onClose, onDismiss, trigger, children }: {
  open: boolean; onClose: () => void; onDismiss: () => void
  trigger: RefObject<HTMLButtonElement | null>; children: ReactNode
}) {
  const popup = useRef<HTMLElement>(null)
  useEffect(() => {
    if (!open) return
    popup.current?.focus({ preventScroll: true })
    const outside = (event: PointerEvent) => {
      const target = event.target as Node
      if (!popup.current?.contains(target) && !trigger.current?.contains(target)) onDismiss()
    }
    const escape = (event: KeyboardEvent) => { if (event.key === 'Escape') { event.preventDefault(); onClose() } }
    document.addEventListener('pointerdown',outside,true)
    document.addEventListener('keydown',escape)
    return () => { document.removeEventListener('pointerdown',outside,true); document.removeEventListener('keydown',escape) }
  }, [open,onClose,onDismiss,trigger])

  // Preserve export settings and in-progress exports while the popup is closed.
  return <section ref={popup} className="board-controls-popover" id="board-controls" hidden={!open} role="dialog" aria-modal="false" aria-labelledby="board-controls-title" tabIndex={-1}>
    <header className="board-controls-header"><h2 id="board-controls-title">Board controls</h2><button aria-label="Close board controls" onClick={onClose}>×</button></header>
    {children}
  </section>
}
